// extracted by mini-css-extract-plugin
export default {"close-icon-wrapper":"CloseButton_close-icon-wrapper__tF-SC"};